import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import ReviewerLapsedNote from '../components/workflow/ReviewerLapsedNote';
import { formatDateShort } from '../utils/dateFormat';
import NowName from '../components/shared/NowName';

// Client Amendment — list page (docs/modules/workflow-client.md §7, docs/workflow-ui.md).
const WorkflowCar = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="Client Amendment"
      newTo="/workflow/car/new"
      canCreate={hasPermission('workflow:client:amendment:submit')}
      apiPath="/api/workflow/car"
      searchPlaceholder="Search request no / requester…"
      width="mid"
      rowTo={(r) => `/workflow/car/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/car/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'entityLabel', label: 'Entity', sortKey: 'entityLabel', render: (r) => <NowName value={r.entityLabel} now={r.entityLabelNow} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => (<><WorkflowStatusBadge status={r.status} /><ReviewerLapsedNote when={r.reviewerLapsed} /></>) },
        { key: 'reviewer', label: 'Reviewer', sortKey: 'reviewer', className: 'whitespace-nowrap', render: (r) => <NowName value={r.reviewerName} now={r.reviewerNameNow} className="text-slate-600" /> },
        { key: 'requester', label: 'Requested By', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowCar;
